import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import BackButton from "../components/BackButton";
import Option from "../components/Option";
import GhostButton from "../components/GhostButton";
import { ReactComponent as ChevronRightIcon } from "../assets/images/icon-chevron-right.svg";
import { withLocalize, Translate } from "react-localize-redux";

import { analytics } from "../utils/Analytics";
import { setLocale } from "../ducks/user";

class UpdateLanguage extends React.Component {
  constructor(props) {
    super(props);

    this.titleSet = false;
    this.changeActiveLanguage = this.changeActiveLanguage.bind(this);
    this.changeRegion = this.changeRegion.bind(this);
  }

  componentDidMount() {
    analytics.pageView("/profile/language", "Update Language");
  }

  UNSAFE_componentWillReceiveProps(newProps) {
    // set page title
    if (typeof newProps.activeLanguage !== "undefined" && !this.titleSet) {
      document.title =
        newProps.translate("title.base") +
        newProps.translate("title.separator") +
        newProps.translate("title.updateLanguage");
      this.titleSet = true;
    }
  }

  buildOptions(languages) {
    if (!languages && !languages.length) return false;

    return languages.map((language, index) => {
      return (
        <Option
          key={index}
          id={index}
          title={language.name}
          selected={language.active}
          clickHandler={this.changeActiveLanguage}
        />
      );
    });
  }

  buildRegionOptions() {
    const { locale } = this.props;

    const regions = [
      { code: "FI", name: "Suomi" },
      { code: "EE", name: "Eesti" },
    ];

    return regions.map((region, index) => (
      <Option
        key={region.code}
        id={index}
        title={region.name}
        selected={locale === region.code}
        clickHandler={this.changeRegion}
      />
    ));
  }

  changeActiveLanguage(option) {
    const newLanguage = this.props.languages.find((language) => {
      return language.name === option.title;
    });

    if (!newLanguage) return false;

    this.props.setActiveLanguage(newLanguage.code);

    localStorage.setItem("language", newLanguage.code);

    // TO-DO: If user is logged in, save language setting to API. Currently not available in API.
  }

  changeRegion(option) {
    const regions = [
      { code: "FI", name: "Suomi" },
      { code: "EE", name: "Eesti" },
    ];

    const newRegion = regions.find((region) => region.name === option.title);

    if (!newRegion) return false;

    if (this.props.setLocale) {
      this.props.setLocale(newRegion.code);
    }
  }

  openCookieSettings() {
    if (window.Cookiebot) {
      window.Cookiebot.renew();
    }
  }

  render() {
    const options = this.buildOptions(this.props.languages);
    const regionOptions = this.buildRegionOptions();

    return (
      <div className="s-settings h-scrollable">
        <div className="s-settings__back">
          <BackButton fallbackRoute="/home" transition="switch-close" />
        </div>

        <div className="s-settings__header">
          <h1 className="s-settings__title">
            <Translate id="updateLanguage.regionTitle" />
          </h1>
          <p className="s-settings__subtitle">
            <Translate id="updateLanguage.regionIntro" />
          </p>
        </div>

        <div className="s-settings__content s-settings__content--no-xpadding">
          <div className="s-settings__options">{regionOptions}</div>
        </div>

        <div className="s-settings__header">
          <h2 className="s-settings__title">
            <Translate id="updateLanguage.title" />
          </h2>
          <p className="s-settings__subtitle">
            <Translate id="updateLanguage.intro" />
          </p>
        </div>

        <div className="s-settings__content s-settings__content--no-xpadding">
          <div className="s-settings__options">{options}</div>
        </div>

        <div className="s-settings__header">
          <h2 className="s-settings__title">
            <Translate id="updateLanguage.cookieTitle" />
          </h2>
          <p className="s-settings__subtitle">
            <Translate id="updateLanguage.cookieIntro" />
          </p>
        </div>

        <div className="s-settings__content">
          <GhostButton
            className="c-btn--cookie-settings"
            text={<Translate id="updateLanguage.cookieButton" />}
            onClick={() => this.openCookieSettings()}
            iconAfter
            icon={<ChevronRightIcon />}
          />
        </div>
      </div>
    );
  }
}

UpdateLanguage.propTypes = {
  languages: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  setActiveLanguage: PropTypes.func,
  locale: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  setLocale: PropTypes.func,
};

function mapStateToProps(state, ownProps) {
  return {
    locale: state.user.locale,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    setLocale: (locale) => dispatch(setLocale(locale)),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withLocalize(UpdateLanguage));
